// ** React Imports
import { lazy } from 'react'
import { Navigate } from 'react-router-dom'

const AdminList = lazy(() => import('../../views/apps/admins/list'))
const OwnerList = lazy(() => import('../../views/apps/owners/list'))
const UserList = lazy(() => import('../../views/apps/users/list'))
const CategoryList = lazy(() => import('../../views/apps/category-types/list'))
const DeliveryList = lazy(() => import('../../views/apps/delivery-types/list'))
const ChoiceList = lazy(() => import('../../views/apps/choice-groups/list'))
const ReviewList = lazy(() => import('../../views/apps/reviews/list'))
const RestaurantList = lazy(() => import('../../views/apps/restaurants/list'))
const OrderList = lazy(() => import('../../views/apps/orders/list'))
const SocialList = lazy(() => import('../../views/apps/social-links/list'))
const SettingList = lazy(() => import('../../views/apps/setting'))
const RoleList = lazy(() => import('../../views/apps/roles/list'))
const SliderList = lazy(() => import('../../views/apps/sliders/list'))
const DrinkList = lazy(() => import('../../views/apps/drinks/list'))
const NotificationList = lazy(() => import('../../views/apps/notifications/list'))
const OrderView = lazy(() => import('../../views/apps/orders/view'))
const RestaurantView = lazy(() => import('../../views/apps/restaurants/view'))
const PrivacyList = lazy(() => import('../../views/apps/privacy-policy/list'))
const TermsList = lazy(() => import('../../views/apps/terms-conditions/list'))
const CouponsList = lazy(() => import('../../views/apps/coupons/list'))
const ReportsList = lazy(() => import('../../views/apps/reports/list'))

const AppRoutes = [
  {
    element: <AdminList />,
    path: '/apps/admin/list'
  },
  {
    element: <OwnerList />,
    path: '/apps/owner/list'
  },
  {
    element: <UserList />,
    path: '/apps/user/list'
  },
  {
    element: <CategoryList />,
    path: '/apps/category-type/list'
  },
  {
    element: <DeliveryList />,
    path: '/apps/delivery-type/list'
  },
  {
    element: <ChoiceList />,
    path: '/apps/choice-group/list'
  },
  {
    element: <ReviewList />,
    path: '/apps/review/list'
  },
  {
    element: <RestaurantList />,
    path: '/apps/restaurant/list'
  },
  {
    element: <RestaurantView />,
    path: '/apps/restaurant/view/:id'
  },
  {
    element: <OrderList />,
    path: '/apps/orders/list'
  },
  {
    element: <SocialList />,
    path: '/apps/social/list'
  },
  {
    element: <OrderView />,
    path: '/apps/order/view/:id'
  },
  {
    element: <SettingList />,
    path: '/apps/setting'
  },
  {
    element: <RoleList />,
    path: '/apps/role/list'
  },
  {
    element: <SliderList />,
    path: '/apps/slider/list'
  },
  {
    element: <DrinkList />,
    path: '/apps/drink/list'
  },
  {
    element: <PrivacyList />,
    path: '/apps/privacy-policy/list'
  },
  {
    element: <TermsList />,
    path: '/apps/terms-conditions/list'
  },
  {
    element: <CouponsList />,
    path: '/apps/coupons/list'
  },
  {
    element: <ReportsList />,
    path: '/apps/reports/list'
  },
  {
    element: <NotificationList />,
    path: '/apps/notification/list'
  }
]

export default AppRoutes
